import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import classnames from 'classnames';
import RadioButton from './radio-button';

class RadioButtonsInput extends Component {
  static displayName = 'RadioButtonsInput';

  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    comment: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    error: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        description: PropTypes.string
      })
    ),
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    hasModal: PropTypes.bool,
    isTextBold: PropTypes.bool,
    style: PropTypes.object,
    learnMore: PropTypes.func,
    direction: PropTypes.oneOf(['vertical', 'horizontal'])
  };
  static defaultProps = {
    options: [],
    hasModal: false,
    direction: 'vertical'
  };

  @autobind
  handleChange(value) {
    this.props.onChange(value);
  }

  render() {
    var {
      title,
      description,
      options,
      value,
      name,
      hasModal,
      comment,
      isTextBold,
      direction
    } = this.props;
    const isCollapsed = !title && !description;
    const style = { ...this.props.style, ...(isCollapsed ? { marginTop: '0px' } : {}) };

    options = options.map((option, index) => {
      var checked = value === option.value;
      return (
        <RadioButton
          key={index}
          name={name}
          text={option.text}
          value={option.value}
          description={option.description}
          checked={checked}
          onClick={this.handleChange}
          isTextBold={isTextBold}
        />
      );
    });
    if (comment) {
      comment = (
        <span className="comment">
          <em>{'Note: '}</em>
          {comment}
        </span>
      );
    }

    return (
      <div className="field" style={style}>
        {title && (
          <div className="field-title">
            {title}
            {hasModal ? (
              <a href="javascript:void(0)" className="title-link" onClick={this.props.learnMore}>
                Learn more
              </a>
            ) : null}
          </div>
        )}
        {description && <div className="field-description">{this.props.description}</div>}
        <div className={classnames('field-options', direction)}>{options}</div>
        {comment}
      </div>
    );
  }
}

export default RadioButtonsInput;
